import get from 'lodash/get';
import { ContentItem } from 'kentico-cloud-delivery';

export default class GlobalMetaTags extends ContentItem {
  get metaTags() {
    return get(this, 'tags', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/GlobalMetaTags.model.js